import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { VisualizationDashboardQuery } from '../../state/dashboard';

@Injectable({ providedIn: 'root' })
export class VisualizationDashboardAclService extends AbstractFeatureAclService<Y42FeatureType.VisualizationDashboard> {
  constructor(query: VisualizationDashboardQuery) {
    super({
      featureType: Y42FeatureType.VisualizationDashboard,
      query,
    });
  }
}
